import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { DISCLAIMER } from "../../../global/variables";
import { getWelcomeText } from "../welcome";
import { BGELD_BUTTONS } from "../../feature-buttons";

export const pageConfigBuergergeld: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.CheckEntitlementToBuergergeldOrAskQuestions),
    welcome: {
        text: getWelcomeText("BGELD"),
        disclaimer: DISCLAIMER,
        buttons: BGELD_BUTTONS,
    },
};
